import { PropertiesType } from '~addListing/types';

const PropertyTypeList = ({
  properties,
  setSelectedProperty,
  className,
  isParent = true,
  setShowContent,
}: {
  properties: PropertiesType[];
  setSelectedProperty: React.Dispatch<
    React.SetStateAction<PropertiesType | null>
  >;
  className?: string;
  isParent?: boolean;
  setShowContent: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
  <ul>
    {properties.map((item: PropertiesType) => (
      <li
        key={item.id}
        className={`${isParent ? 'border-b border-gray last:border-b-0 p-0' : ''}`}
      >
        <p
          className={`${className} py-x px-1.5x cursor-pointer hover:bg-gray_light_1`}
          onClick={() => {
            setSelectedProperty(item);
            setShowContent(false);
          }}
        >
          {item.singularName}
        </p>
        {item.children.length > 0 && (
          <PropertyTypeList
            properties={item.children}
            setSelectedProperty={setSelectedProperty}
            className="!text-gray__dark_2 !text-body_2"
            isParent={false}
            setShowContent={setShowContent}
          />
        )}
      </li>
    ))}
  </ul>
);

export default PropertyTypeList;
